import React from 'react';
import { CTDropDownMulti, CTDatePickerRange } from "components";
import './advanceSearch.css';
import { useEffect } from 'react';

const AdvanceSearch = ({
    categoryAdvanceSearch,
    provider,
    hospitals,
    selectedCategories,
    selectedProviders,
    selectedHospitals,
    handleCategoryChange,
    handleProviderChange,
    handleHospitalChange,
    onApplySearch,
    onClose,
    onClearSearch,
    onDateChange,
    type
}) => {
    useEffect(() => {
        console.log(categoryAdvanceSearch, "categoryAdvanceSearch in advance search")
        console.log(provider, "provider in advance search")
        console.log(hospitals, "hospitals in advance search")
    }, [])
    return (
        <div className="advance-search-container">
            <div className="advance-search-panel">
                <div className="advance-search-header p-3 border-bottom">
                    <h5 className="text-start fw-bold mb-0">Advanced Search</h5>
                </div>
                <div className="advance-search-body p-3">
                    <div className="mb-3">
                        <CTDropDownMulti
                            data={categoryAdvanceSearch}
                            placeholder="Search by Category"
                            handleChange={handleCategoryChange}
                            value={selectedCategories}
                        />
                    </div>
                    <div className="mb-3">
                        <CTDropDownMulti
                            data={provider}
                            placeholder="Search by Provider"
                            handleChange={handleProviderChange}
                            value={selectedProviders}
                        />
                    </div>
                    <div className="mb-3">
                        <CTDropDownMulti
                            data={hospitals}
                            placeholder="Search by Clinic/Diagnosis Center"
                            handleChange={handleHospitalChange}
                            value={selectedHospitals}
                        />
                    </div>
                    <div className="mb-4">
                        <CTDatePickerRange  onDateChange={onDateChange} type={type} placeholder="Search by report date range"/>
                    </div>
                    <div className="d-flex justify-content-between mt-4">
                        <button
                            className="btn btn-primary"
                            style={{ textTransform: "none", fontSize: "14px" }}
                            onClick={onApplySearch}
                        >
                            Apply Search
                        </button>
                        <button
                            className="btn btn-warning"
                            style={{ textTransform: "none", fontSize: "14px", fontWeight: "bold" }}
                            onClick={onClearSearch}
                        >
                            Clear Search
                        </button>
                    </div>
                    <div className="d-flex justify-content-center mt-3">
                        <button
                            className="btn btn-danger"
                            onClick={onClose}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdvanceSearch;
